/* Angular */
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

/* Partials for CRUD */
import {
	ActionNotificationComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
	AlertEntityDialogComponent,
	ConfirmEntityDialogComponent,
	DynamicDialogComponent
} from '../../../../views/partials/content/crud';
import { ConfirmEntityWithInputComponent } from '../../../../views/partials/content/crud/confirm-entity-with-input/confirm-entity-with-input.component';

export enum MessageType {
	Create,
	Read,
	Update,
	Delete
}

export enum NotificationType {
	INFO = 'info',
	WARNING = 'warning',
	ERROR = 'error',
	SUCCESS = 'success'
}

interface IDeleteInput {
	title: string,
	description: string,
	waitDesciption: string,
	deleteMessage: string
}

@Injectable()
export class LayoutUtilsService {
	constructor(private readonly snackBar: MatSnackBar,
		private readonly dialog: MatDialog) { }

	showActionNotification(
		_message: string,
		_type: MessageType = MessageType.Create,
		_duration: number = 10000,
		_showCloseButton: boolean = true,
		_showUndoButton: boolean = false,
		_undoButtonDuration: number = 3000,
		_verticalPosition: 'top' | 'bottom' = 'bottom',
		_messageType: NotificationType = NotificationType.INFO
	) {
		const _data = {
			message: _message,
			snackBar: this.snackBar,
			showCloseButton: _showCloseButton,
			showUndoButton: _showUndoButton,
			undoButtonDuration: _undoButtonDuration,
			verticalPosition: _verticalPosition,
			type: _type,
			messageType: _messageType,
			action: 'Undo'
		};
		return this.snackBar.openFromComponent(ActionNotificationComponent, {
			duration: _duration,
			data: _data,
			verticalPosition: _verticalPosition,
			panelClass: ['snackbar-notification', _messageType]
		});
	}

	dynamicElement(title: string = '', description: string = '', cancelMessage = "Cancel", okMessage = "Ok", hideLoading = true) {
		return this.dialog.open(DynamicDialogComponent, {
			data: { title, description, cancelMessage, okMessage, hideLoading },
			width: '440px'
		});
	}

	deleteElement(title: string = '', description: string = '', waitDesciption: string = '') {
		return this.dialog.open(DeleteEntityDialogComponent, {
			data: { title, description, waitDesciption },
			width: '440px'
		});
	}

	deleteElementWithCloseResponse(options: IDeleteInput) {
		const { title, description, waitDesciption, deleteMessage } = options;
		const dialogRef = this.dialog.open(DeleteEntityDialogComponent, {
			data: { title, description, waitDesciption },
			width: '440px'
		});
		return dialogRef.afterClosed();
	}

	alertElement(message: string = '') {
		return this.dialog.open(AlertEntityDialogComponent, {
			data: { message },
			width: '440px'
		});
	}

	confirmElement(message: string = '', title: string = 'Message') {
		return this.dialog.open(ConfirmEntityDialogComponent, {
			data: { message, title },
			width: '440px'
		});
	}

	/** Single-text-input dialog. Resolves (afterClosed) to { inputValue } on OK, undefined on cancel. */
	promptInput(opts: { title?: string; placeholder?: string; okMessage?: string; cancelMessage?: string; validator?: (v: string) => boolean } = {}) {
		return this.dialog.open(ConfirmEntityWithInputComponent, {
			data: {
				title: opts.title || 'Enter value',
				placeholder: opts.placeholder || '',
				okMessage: opts.okMessage || 'Ok',
				cancelMessage: opts.cancelMessage || 'Cancel',
				validator: opts.validator || ((v: string) => !v || !v.trim()),
				hideLoading: true
			},
			width: '440px'
		});
	}

	fetchElements(_data) {
		return this.dialog.open(FetchEntityDialogComponent, {
			data: _data,
			width: '400px'
		});
	}

	updateStatusForEntities(title, statuses, messages) {
		return this.dialog.open(UpdateStatusDialogComponent, {
			data: { title, statuses, messages },
			width: '480px'
		});
	}
	getEmptyLayout(message) {
		return {
			"xaxis": {
				"visible": false
			},
			"yaxis": {
				"visible": false
			},
			"annotations": [
				{
					"text": message,
					"xref": "paper",
					"yref": "paper",
					"showarrow": false,
					"font": {
						"size": 24
					}
				}
			],
			height: 400
		}

	}
}
